exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HocBadges___3V-9f {\n  padding: 0.125rem 0.25rem;\n  user-select: none;\n}\n\n.Badge___yfw97 {\n  display: inline-block;\n  background-color: var(--color-component-badge-background);\n  color: var(--color-text);\n  padding: 0.125rem 0.25rem;\n  line-height: normal;\n  border-radius: 0.125rem;\n  margin-right: 0.25rem;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n}\n", ""]);

// exports
exports.locals = {
	"HocBadges": "HocBadges___3V-9f",
	"Badge": "Badge___yfw97"
};